export default "__VITE_ASSET__DMJb76ih__"